<template>
  <div v-if="status === 'success'">
    <div v-if="isValidArray(items)" :style="`height: ${height}px;`">
      <v-layout
        wrap
        justify-center
        :fill-height="items.length > 4"
      >
        <v-flex
          v-for="(item, index) in items"
          :key="`item-${index}`"
          class="list__item"
          xs12
        >
          <span class="list__item__wrapper">
            <span class="list__item__title text--ellipsis" @click="handleClick(item)">
              {{ item.name }}
            </span>
            <span class="list__item__value">
              {{ item.value }} <span class="text--small text--regular">({{ item.percent | formatPercentage }})</span>
            </span>
          </span>
          <span class="list__item__progress">
            <span class="list__item__bar" :style="`width: ${item.percent}%`"></span>
          </span>
        </v-flex>
      </v-layout>
    </div>

    <v-layout
      v-else
      class="text--center text--small"
      :style="`height: ${height}px;`"
      align-center
      justify-center
      :fill-height="items.length > 4"
    >
      <div>
        <p><strong v-html="$t(`${namespace}.${type}.empty`)" /></p>
        <p class="mb-0">
          <span v-html="$t(`${namespace}.${type}.help`)" /><br>
          <a :href="faqLink" :title="$t('Common.clickHere')" target="_blank">{{ $t('Common.clickHere') }}</a>&nbsp;
          <span v-html="$t(`${namespace}.learnMore`)" />
        </p>
      </div>
    </v-layout>
  </div>
</template>

<script>
import { isValidArray } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'Success',
  props: {
    type: {
      type: String
    },
    status: {
      type: String,
      default: 'loading'
    },
    height: {
      type: [String, Number]
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    faqLink () {
      const links = {
        costCenters: 'https://99empresas.zendesk.com/hc/pt-br/sections/360010848974-Centros-de-custo',
        employees: 'https://99empresas.zendesk.com/hc/pt-br/sections/360010849094-Colaborador'
      }

      return links[this.type] || ''
    }
  },
  data () {
    return {
      namespace: 'Components.Top5'
    }
  },
  methods: {
    isValidArray (val) {
      return isValidArray(val)
    },

    handleClick ({ info }) {
      if (this.type === 'costCenters') {
        const { id, name } = info

        return this.$emit('openGlobalDrawer', {
          type: 'costCenter',
          data: { id, name }
        })
      }

      if (this.type === 'employees') {
        const { employeeId: id, employeeName: name } = info

        this.$emit('openGlobalDrawer', {
          type: 'employee',
          data: { id, name }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  font-weight: 700;
  padding-left: 18px;
}

.list__item {
  margin-top: 16px;
}

.list__item__wrapper {

  &:after {
    clear: both;
    content: '';
    display: block;
    height: 1px;
    width: 100%;
  }
}

.list__item__title,
.list__item__value {
  float: left;
  font-weight: normal;
  width: 50%;
}

.list__item__title {
  color: $accent;
  cursor: pointer;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
}

.list__item__value {
  color: var(--gray-7);
  font-family: $title-font;
  font-weight: 600;
  text-align: right;
}

.list__item__progress {
  background-color: $gray-1;
  display: block;
  height: 5px;
}

.list__item__bar {
  background-color: $info-2;
  display: block;
  height: 5px;
}
</style>
